import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";

import type { EmailTemplateResource } from "@exonn/js-sdk";
import type { Module } from "src/system/module.types.ts";
import { getResourceFieldOptions } from "src/system/getResourceFieldOptions.ts";

export const module: Module<EmailTemplateResource> = {
  id: ResourceEnum.EmailTemplate,
  bigIcon: <span className={"icon-20-email_tmpl"} />,
  smallIcon: <span className={"icon-15-email_tmpl"} />,
  name: (t: TFunction) => t("moduleName.email-template"),
  tabs: {
    edit: {
      getTitle: (resource, t) => {
        return getResourceFieldOptions({
          t,
          resource: ResourceEnum.EmailTemplate,
          field: "email_type",
        }).find((option) => option.value === resource.email_type)?.label;
      },
    },
  },
  disableDelete: true,
  disableCreate: true,
};
